import { Badge, Box, Button, Divider, Flex, Text, useColorModeValue, useDisclosure, VStack } from '@chakra-ui/react';
import { IoIosArrowDropdown } from 'react-icons/io';
import MoreDetailMobilePage from './moreDetail';
import { memo } from 'react';
import LabelWithValueMobilePage from '../../../../../components/Mobile/labelWithValue';

export interface IResourceItem {
  id: string;
  code?: string;
  createdAt?: string;
  question?: string;
  status: string;
  proofSubject?: string;
}

interface IOwnProps {
  item: IResourceItem;
  isImpugnation: boolean;
  isUpdateOrDelete?: boolean;
  onOpenUpdateResource(id: string): void;
}

const CardDetailMobilePage: React.FC<IOwnProps> = ({ item, isImpugnation, isUpdateOrDelete, onOpenUpdateResource }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const { isOpen, onToggle } = useDisclosure();

  const statusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'deferido':
        return 'green';
      case 'em análise':
        return 'yellow';
      case 'indeferido':
        return 'red';
      case 'parecer publicado':
        return 'orange';
      default:
        return 'gray';
    }
  };

  return (
    <Box px={4} py={3} bg={cardBg} borderRadius="md" shadow="md" w="100%">
      <Flex justifyContent="space-between" alignItems="center">
        <VStack alignItems="initial" spacing={0}>
          <Text mb="-2px" fontWeight="semibold" fontSize="0.9rem">
            {isImpugnation ? 'Protocolo' : 'Recurso'} Nº{item.code}
          </Text>
          <Text mb={2} fontSize="0.7rem" color="gray.500">
            Enviado em: {item.createdAt}
          </Text>
          {item.question && <LabelWithValueMobilePage label="Questão" value={item.question} />}
          {item?.proofSubject && <LabelWithValueMobilePage label="Prova" value={item.proofSubject} />}
        </VStack>
        <VStack spacing={4} height="100%">
          <Badge fontSize="x-small" px={2} colorScheme={statusColor(item.status)}>
            {item.status}
          </Badge>
        </VStack>
      </Flex>
      {isUpdateOrDelete && (
        <Button onClick={() => onOpenUpdateResource(item.id)} py={1.5} mt={1} fontSize="xs" w="full" h="fit-content">
          Atualizar
        </Button>
      )}
      <MoreDetailMobilePage isImpugnation={isImpugnation} id={item.id} isOpen={isOpen} />
      <Divider my={2} color="gray.400" />
      <Flex gap={1} cursor="pointer" onClick={onToggle} justifyContent="center" alignItems="center">
        <Box transform={`rotate(${isOpen ? 180 : 0}deg)`} transition="transform 0.3s ease">
          <IoIosArrowDropdown />
        </Box>
        <Text>Mostrar {isOpen ? 'menos' : ''} detalhes</Text>
      </Flex>
    </Box>
  );
};

export default memo(CardDetailMobilePage);
